<template>
    <el-menu
        :router="true"
        :default-active="$route.path"
        mode="horizontal"
        :ellipsis="false"
        :popper-offset="0"
        background-color="#1f3864"
        text-color="#ffffff"
        active-text-color="#ffffff"
        class="header-menu"
        ref="menubar"
    >
        <el-menu-item index="" @click="setSidebarMinimized(!isSidebarMinimized)">
            <el-icon style="margin: 0"><Expand v-if="isSidebarMinimized" /><Fold v-else /></el-icon>
        </el-menu-item>
        <el-menu-item :index="resolveRoutePath ('HomePage')">
            <h1>{{ $appName }}</h1>
        </el-menu-item>
        <div class="flex-grow"></div>
        <template v-if="isLoggedIn">
            <TasksMenuItem />
            <el-sub-menu index="2">
                <template #title><el-icon><User /></el-icon>{{userinfo.first_name}} {{userinfo.last_name}}</template>
                <el-menu-item :index="resolveRoutePath ('UserProfilePage')">Profile</el-menu-item>
                <el-menu-item @click="tryLogout()">Logout</el-menu-item>
            </el-sub-menu>
        </template>
        <el-menu-item v-else :index="resolveRoutePath ('LoginPage')">
            <span>Login</span>
        </el-menu-item>
    </el-menu>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

import TasksMenuItem from '@/components/tasks/MenuItem'

export default {
    name: 'NavigationMenu',
    components: {TasksMenuItem},
    data: () => ({
        pendingActions: []
    }),
    computed: {
        ...mapGetters('auth', ['isLoggedIn', 'userinfo']),
        ...mapGetters('ui', [ 'isSidebarMinimized' ]),
    },
    methods: {
        ...mapActions('auth', ['logout']),
        ...mapActions('ui', ['setSidebarMinimized']),

        resolveRoutePath (pathName) {
            if (!pathName) {
                return ''
            }
            return this.$router.resolve({
                name: pathName
            })?.path
        },
        async tryLogout () {
            await this.logout()
            this.$router.push({name: 'HomePage'})
        },
    }
}
</script>

<style scoped>
.flex-grow {
  flex-grow: 1;
}

.el-menu--horizontal.el-menu.header-menu {
    border-bottom: none;
}

</style>
